<script context="module">
    import { getMethod } from "./Get.svelte";
    import { postMethod } from "./Post.svelte";
    import { putMethod } from "./Put.svelte";
    import { deleteMethod } from "./Delete.svelte";

    export const apiMethods = {
        getMethod,
        postMethod,
        putMethod,
        deleteMethod,
    };
</script>
